module.exports = __webpack_public_path__ + "img/unkwown.b706323e.svg";